import React from 'react';
import ManageSessionModal from './modifySessionModal';
import ViewsModal from './viewsModal';
import ManageStudentModal from './modifyStudentModal';
import ManageTutorModal from './modifyTutorModal';
import '../../../css/modal.css'

const selectedStudentTemplate = ({ data, callbacks }) => {
  const onShowSessions = ({id}) => {
    callbacks.showSessions(id);
    callbacks.onClose(null)
  }
  
  const onCreateSession = () => {
    callbacks.setModalTemplate("createSession")
  }

  return (
    <>
      <h1>Name: {data.name} (id: {data.studentId})</h1>
      <h3>Sessions</h3>
      <button onClick={() => onShowSessions(data.studentId)}>Show Sessions</button>
      <button onClick={() => onCreateSession()}>Create Session</button>
    </>
  );
};


/**
 * ModalManager component renders a modal based on the provided template name.
 * It dynamically selects a template component from a predefined set and passes the necessary data and callbacks to it.
 * 
 * ---
 * 
 * @param {string} template - The name of the template to display (e.g., "studentData", "tutorData").
 * @param {Object} data - The data to be passed to the selected template.
 * @param {Object} callbacks - A set of callback functions, including an `onClose` function to close the modal.
 * 
 * @returns {JSX.Element} The rendered modal with the selected template component.
 */
const ModalManager = ({ template, data, callbacks }) => {

  const templates = {
    createStudent: (props) => <ManageStudentModal {...props} mode="create" />,
    editStudent: (props) => <ManageStudentModal {...props} mode="editWithName" />,
    createTutor: (props) => <ManageTutorModal {...props} mode="create" />,
    editTutor: (props) => <ManageTutorModal {...props} mode="editWithName" />,
    selectedStudent: selectedStudentTemplate,
    createSession: (props) => <ManageSessionModal {...props} mode="create" />,
    editSession: (props) => <ManageSessionModal {...props} mode="editWithName" />,
    viewsModal: ViewsModal
  };

  const TemplateComponent = templates[template];

  if (!TemplateComponent) {
    return <div>Template not found</div>;
  }

  return (
  <div>
    {typeof TemplateComponent === 'function' ? (
      TemplateComponent({ data, callbacks })
    ) : (
      <TemplateComponent data={data} callbacks={callbacks} />
    )}
  </div>

  );
};


export default ModalManager
